import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery, getBaseUrl } from '../api.util.ts'
import {
  SendInviteEmailRequest,
  UserCreateRequest,
  UserListRequest,
  UserListResponse,
  UserResponse,
  UserUpdateRequest,
  UserUpdateResponse,
} from './user-management-api.def.ts'

const interfaceName = 'user'

export const userManagementApi = createApi({
  reducerPath: 'userManagementApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName)),
  tagTypes: ['managed-user'],
  endpoints: (build) => ({
    listUsers: build.query<UserListResponse, UserListRequest>({
      query: (params) => ({
        url: '/list',
        method: 'GET',
        params: params,
      }),
      providesTags: ['managed-user'],
    }),
    createUser: build.mutation<void, UserCreateRequest>({
      query: (payload) => ({
        url: '/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['managed-user'],
    }),
    updateUser: build.mutation<UserUpdateResponse, UserUpdateRequest>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['managed-user'],
    }),
    getUser: build.query<UserResponse, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'GET',
      }),
      providesTags: ['managed-user'],
    }),
    sendInviteEmail: build.query<void, SendInviteEmailRequest>({
      query: (payload) => ({
        url: `${payload.id}/send-invite-email`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const {
  useListUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useGetUserQuery,
  useLazySendInviteEmailQuery,
} = userManagementApi
